define.alias("shared/components/shared/color-picker", "settings/components/shared/color-picker");